export default __webpack_public_path__ + "static/media/logo-new.6b18e9c2.svg";